export default __webpack_public_path__ + "static/media/foxify.733c4ab6.png";